import mapKidsTaxToRequest from './mappers/mapKidsTaxToRequest'

export default function(api: GlobalFetch) {
  return async function(values, objectId, calendarId) {
    const requestBody = mapKidsTaxToRequest(values, objectId, calendarId)
    const response = await api.fetch(`/api/v2/price/tax`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.ok) {
      return response.status.toString()
    } else {
      throw new Error(response.status.toString())
    }
  }
}
